// Reference page size used by buttonStamp.js (A4 portrait in PDF points)
const REF_W = 595
const REF_H = 842
const STAMP_W = 200
const MARGIN_X = 11

/**
 * Remap hardcoded A4-portrait stamp coords to the actual page size.
 * Portrait / square pages keep the original coords unchanged.
 */
export function resolveStampCoords(cordX, cordAllY, cordRectX, pageWidth, pageHeight) {
  if (!pageWidth || !pageHeight || pageWidth <= pageHeight) {
    return { cordX, cordAllY, cordRectX }
  }

  const colOffset = cordRectX - cordX
  const isLeft = cordX < 100
  const isRight = cordX > 300

  const nextX = isLeft ? MARGIN_X : isRight ? pageWidth - STAMP_W - MARGIN_X : (pageWidth - STAMP_W) / 2

  return {
    cordX: nextX,
    cordRectX: nextX + colOffset,
    cordAllY: cordAllY * (pageHeight / REF_H),
  }
}
